export const IbanAgriList = [
  {
    
    img_src: "https://66.media.tumblr.com/008125c44da37036270c16dac66913ff/92f31b00ed414afa-45/s400x600/25383c50cfdec648f17b4eda6c967e6ddb46fce2.png",
    name: "Duku",
    alt: 'duku',
    description: "Duku is an agricultural tool that is used to prune grass before the area becomes a place of planting. On top of that, previous Iban community in Simunjan also used the tool for butchering.",
  },

  {
    img_src:"https://66.media.tumblr.com/dfd369df65efbae1c66e430d28e63a0a/92f31b00ed414afa-81/s540x810/4498ecf3b14da27b490b974678c2b56bd0d52c68.png",
    name: "Gergaji Buaya",
    alt: 'gergaji-buaya', 
    description: "Gergaji Buaya is a saw used to cut trees. The saw requires 2 people to use it. It is made out of metal slate or iron.",

  },

  {
    img_src: "https://66.media.tumblr.com/1dc06fc7c2f544996c3523add91214fb/92f31b00ed414afa-55/s540x810/e6551c8dba11b56dce06bd75838a9bccf7aa65dd.png",
    name: "Pengisar",
    alt: 'pengisar',
    description: "Pengisar is made out of a large hard wood. It is an equipment used to grind paddy. The Pengisar has two holders whereby it requires both hands to handle the equipment.",
  },

  
];

export const IbanHandiList = [
  {
    img_src: "https://66.media.tumblr.com/b8b864e03740d00476f39508965ee4b2/dd4a84b87f4e6515-38/s250x400/07d7b58c58912fb711b1129392d420fb2c2cd43c.png",
    name: "Lanjik",
    alt: 'lanjik',
    description: "Lanjik (Bakul Rotan) is made of nipah leaves and is decorated with bamboo and nipah. There are other societies who believe that the basket is related to the occult creatures.",
  },

  {
    img_src: "https://66.media.tumblr.com/1b4251187b38e4d61063dea3859f811b/dd4a84b87f4e6515-92/s540x810/fecedf9d9f6844312ed9f7445ceea36ba5e2b327.png",
    name: "Teresang",
    alt:'teresang',
    description: "Teresang is made from bamboo. It is used during 'Miring' ritual to present the ritual item 'Petara' to the gods.",

  },

  {
    img_src: "https://66.media.tumblr.com/ecbf02f49edaae784adf3fa44bbe5eed/dd4a84b87f4e6515-8a/s400x600/a276df903fd839503698e6a37bc888dd86d3ca8c.png",
    name: "Kuna",
    alt: 'kuna',
    description: "Kuna is an artefact made of copper. Traditionally, Kuna is where people keep their clothes and accessories in.",
  },

  {
    img_src: "https://66.media.tumblr.com/371a85f4ef208e54d379fa47d44701c6/dd4a84b87f4e6515-bb/s540x810/058dbbe09ad64329110e0445728ea12ff1d6153c.png",
    name: "Tajau",
    alt: 'tajau',
    description: "Tajau is highly appreciated by the Iban community as a family heirloom. Tajau is also used during sacred ceremonies and celebrations of original beliefs. Some believes that Tajau has supernatural abilites. ",
  },

  {
    img_src:"https://64.media.tumblr.com/61ead4e154429cde2cf89834332cbdd7/63e6bebe18a88fa5-53/s540x810/ff3438adf81c6f86587fb16b6bb4ab11d3a3edfb.jpg",
    name: "Tanggui",
    alt: 'tanggui',
    description:"A headwear that is used to shield the wearer from the hot sun. Tanggui is made from Nipah leaves.",
  },

  {
    img_src:"https://64.media.tumblr.com/5381e186fc47690e12629a34aaa63ce2/63e6bebe18a88fa5-d2/s540x810/ded007059f5d8eb1e180b1e7d5cb73f5c063ce81.jpg",
    name:"Cupai",
    alt: 'cupai',
    description:"Cupai is a small bag that is used carry farming needs.", 
  },

];

export const IbanMusicList = [ 
  {
    name: "Gendang Pampat",
    img_src: "https://66.media.tumblr.com/c2f5e8f8b34002ee60a26ff99fe7807d/dd4a84b87f4e6515-57/s540x810/d5d530cc65ebef881a8b3583ec2b432e9179e587.png",
    sub_img: "https://66.media.tumblr.com/c2f5e8f8b34002ee60a26ff99fe7807d/dd4a84b87f4e6515-57/s540x810/d5d530cc65ebef881a8b3583ec2b432e9179e587.png",
    description: "Gendang Pampat is usually made out of a hard wood such as 'Ketapang'. It was shaped into a cylinder and has a length up to a metre. The surface of the Gendang is made from goat's skin. To play Gendang Pampat requires a mantra recitation.",
    url: "Gendang-Pampat"
  },

  {
    name: "Bebendai",
    img_src: "https://66.media.tumblr.com/184e804e0bebdbb8f99946502742faaa/222614d4626ae98a-b5/s540x810/01cbb539f4a96cbe80a732891905da8a155bd1ba.png",
    sub_img:"https://66.media.tumblr.com/184e804e0bebdbb8f99946502742faaa/222614d4626ae98a-b5/s540x810/01cbb539f4a96cbe80a732891905da8a155bd1ba.png",
    description:"The Bebendai has the same shape as another musical instrument called the 'Tawak'. The walls of Bebenai are thick and middle part is decayed.",
    url:"Bebendai"

  },

  {
    name: "Tawak",
    img_src:"https://66.media.tumblr.com/f3a7b882cccbf6fafb1411348fa4a6c0/222614d4626ae98a-ad/s540x810/dde9596a464c920f32852fbd20b4ad97e57b7d1c.png",
    sub_img:"https://66.media.tumblr.com/f3a7b882cccbf6fafb1411348fa4a6c0/222614d4626ae98a-ad/s540x810/dde9596a464c920f32852fbd20b4ad97e57b7d1c.png",
    description:"Tawak is a small gong made from 'perunggu'. Interestingly, the Tawak can produce different sounds like 'chak', 'dong', and 'peng'.",
    url:"Tawak"
  },

];

export const IbanWeaponList = [ 
  {
    img_src: "https://66.media.tumblr.com/1d8067b8993b3cebdd1c4ae31e818089/dd4a84b87f4e6515-2b/s540x810/8e08e51a360299cf29e0f23e93cb33494a39b08c.png",
    name: "Parang Ilang",
    alt:'parang-ilang',
    description: "Parang Ilang was used as a weapon during the era of colonization. After World War II, the Ibans use it to carry out daily activities. Its manufacturing process requires a high degree of patience and persistence. Each steps in the manufacturing process was accompanied by prayer and rituals.",
  },

  {
    img_src: "https://66.media.tumblr.com/8b5a37454e0a76ceda2b5f4856662d3f/dd4a84b87f4e6515-3c/s540x810/23bc60b18614800e5a210ebd100df1f6f0b51fb0.png",
    name: "Tobak",
    alt:'tobak',
    description: "Tobak is a hunting equipment. It is a spear rod made of wood with a spear eye tied at the tip.",
  },

  {
    img_src: "https://66.media.tumblr.com/4b3acf439e82ec64306fe63d7ca1705a/dd4a84b87f4e6515-0f/s540x810/c73369588a6d2632ae13602ece4c6d5103bf687a.png",
    name: "Terabai",
    alt:'terabai',
    description: "Terabai is a tool used in war. Iban men used Terabai for figting, killing, and defending the state from its enemies. It is made of plait wood and is carved and pained according to the preferences of its owner. Today, the Terabai is mainly used in a dance and opening ceremonies.",
  },
];